export default __webpack_public_path__ + "static/media/no-img.2fda6558.png";